(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snip-product-app"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cro-ar-availability')) {
    customElements.define('cro-ar-availability', class extends HTMLElement {
      constructor() {
        super();
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        this.productSection = this.closest('[data-section-type="product__section"]');
        this.productSection?.addEventListener('change', this.onVariantChange);
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.productSection?.removeEventListener('change', this.onVariantChange);
      }

      onVariantChange(event) {
        if (event.target.matches('.js-variant-selector')) {
          this.hidden = true;
          return;
        }
        if (event.target.matches('.formVariantId, [name="id"]')) {
          this.updateVisibility(event.target.value);
        }
      }

      updateVisibility(variantId) {
        variantId = variantId || this.productSection?.querySelector('.formVariantId[name="id"]')?.value || this.dataset.variantId;
        const image = this.querySelector(`[id="img-url-${variantId}"]`)?.value?.trim();
        const dimensions = this.querySelector(`[id="dimensions-${variantId}"]`)?.value?.trim();
        const nvznId = this.querySelector('[id="nvzn-id"]')?.value?.trim();
        this.hidden = !(nvznId && image && image !== '/' && dimensions && dimensions !== 'x');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
